/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Audio_Description_Export_Status_Creating_SegmentInputs */

const en_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creating segment ${i?.current}/${i?.total}...`)
};

const fr_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Création du segment ${i?.current}/${i?.total}...`)
};

const de_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstelle Segment ${i?.current}/${i?.total}...`)
};

const it_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creazione del segmento ${i?.current}/${i?.total}...`)
};

const ru_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создание сегмента ${i?.current}/${i?.total}...`)
};

const es_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creando el segmento ${i?.current}/${i?.total}...`)
};

const zh_cn2_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`创建段 ${i?.current}/${i?.total}...`)
};

const ja_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`セグメント ${i?.current}/${i?.total} を作成しています...`)
};

const hi_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सेगमेंट ${i?.current}/${i?.total} बनाया जा रहा है...`)
};

const pt_pt2_audio_description_export_status_creating_segment = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Criando segmento ${i?.current}/${i?.total}...`)
};

/**
* | output |
* | --- |
* | "Creating segment {current}/{total}..." |
*
* @param {Audio_Description_Export_Status_Creating_SegmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_segment = /** @type {((inputs: Audio_Description_Export_Status_Creating_SegmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_SegmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_creating_segment(inputs)
	if (locale === "de") return de_audio_description_export_status_creating_segment(inputs)
	if (locale === "it") return it_audio_description_export_status_creating_segment(inputs)
	if (locale === "ru") return ru_audio_description_export_status_creating_segment(inputs)
	if (locale === "es") return es_audio_description_export_status_creating_segment(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_creating_segment(inputs)
	if (locale === "ja") return ja_audio_description_export_status_creating_segment(inputs)
	if (locale === "hi") return hi_audio_description_export_status_creating_segment(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_creating_segment(inputs)
	return en_audio_description_export_status_creating_segment(inputs)
});